import {types, useUser} from "../auth/UserContext";
import Kian from "../Kian";
import axios from "axios";
import Config from "../config";

function useEntityObject(entity) {

    const user = useUser();

    /**
     *
     * @param onResult is an event that returns the results when received.
     * @param filters is an object contains the entity's field and values to filter the results.
     * @param fields is an array of the entity's fields
     * @returns {Promise<void>}
     */
    const fetch = async ({onResult, onError, fetchBody=null ,filters = undefined, filterType="and", fields = Object.keys(entity.fields), join, xmlFilter, orderBy, page=1, count=0})=>{
        // Object.keys(filters).forEach((f)=>{
        //     if (filters[f]===undefined){
        //         delete filters[f];
        //     }
        // })
        const headerConfig = {
            headers:{
                "Authorization": `Bearer ${user.state.userData.token}`,//testToken
                "Content-Type": 'application/xml'
            }

        };
        let body = fetchBody?fetchBody:`<fetch page="${page}" count="${count}">
                    <entity name="${entity.name}">
                    ${fields.map((attr)=>(`<attribute name="${attr}" />`)).join("")}

                    ${xmlFilter?(xmlFilter):(`${filters ? `<filter type="${filterType}">
                            ${Object.keys(filters).map((f)=>(`<condition attribute="${f}" operator="eq" value="${filters[f]}" />`)).join("")}
                            </filter>`:""}`)}
                    
                    ${join? join.map((joinedEntity)=>(`<link-entity name="${joinedEntity.entity.name}" from="${joinedEntity.from}" to="${joinedEntity.to}" link-type="${joinedEntity.type}" >
                                                        ${Object.keys(joinedEntity.entity.fields).map((joiendEntityField)=>(`<attribute name="${joiendEntityField}"/>`))}
                                                       </link-entity>`)) :""}
                    
                    ${orderBy? orderBy.map((order)=>(`<order attribute="${order.attributeName}" descending="${order.descending}" />`)) :""}
                    </entity>
                </fetch>`
        try {
            let data = await Kian.post(`/Fetch/${entity.name}s`, body, headerConfig);
            onResult(data);
        }
        catch (e) {
            if (e.response && e.response.status===401)user.logout();
            onError && onError(e)
        }
    }

    /**
     *
     * @param onResult is an event that returns the results when received.
     * @param filename a string filename.
     */
    const fetchLocal = async ({onResult})=>{
        try {
            let data = await axios.get(`assets/data/${entity.name}.json`);
            onResult(data);
        }
        catch ({response}) {
        }
    }

    /**
     *
     * @param onResult is an event that returns the results when received.
     * @param body is an object of field and values to create a row of the entity.
     * @param bind is a two params array [Entity, id] to bind the entity to another entity
     * @returns {Promise<void>}
     */
    const create = async ({onResult, body, bind = undefined})=>{

        const headerConfig = {
            headers:{
                "Authorization": `Bearer ${user.state.userData.token}`,
            }
        };
        try {
            if (bind){
                const [field, bindedEntity, id] = bind;
                body[`${field}_${bindedEntity.name}@odata.bind`] = `/${bindedEntity.name}s(${id})`;
            }
            let data = await Kian.post(`/Proxy/${entity.name}s`, body , headerConfig);
            onResult && onResult(data);
        }
        catch (e) {
            if (e.response && e.response.status===401)user.logout();
            // console.log(e);
        }
    }

    /**
     *
     * @param onResult is an event that returns the results when received.
     * @param id is a specific row uuid of the entity .
     * @param body is an object of field and values to update a row of the entity.
     * @returns {Promise<void>}
     */
    const update = async ({onResult, onError, id, body})=>{

        const headerConfig = {
            headers:{
                "Authorization": `Bearer ${user.state.userData.token}`,
            }
        };
        try {
            let data = await Kian.patch(`/Proxy/${entity.name}s(${id})`, body, headerConfig);
            onResult && onResult(data);
        }
        catch (e) {
            if (e.response && e.response.status===401)user.logout();
            onError && onError(e);
            // console.log(e);
        }
    }

    /**
     *
     * @param onResult is an event that returns the results when received.
     * @param filters is an object contains the entity's field and values to filter the results.
     * @param fields is an array of the entity's fields
     * @returns {Promise<void>}
     */
    const toExcel = async ({onResult, onError, filters = undefined, fields = Object.keys(entity.fields), join, xmlFilter, orderBy, page=1, count=0, fieldsTranslate, fileName})=>{

        let excelFieldHeaders = [];
        fields.forEach((f)=>{
            excelFieldHeaders.push({FieldName:fieldsTranslate[f].formated_key, Title:fieldsTranslate[f]?fieldsTranslate[f].value:f})
        })

        const headerConfig = {
            headers:{
                "Authorization": `Bearer ${user.state.userData.token}`,//testToken
                "Content-Type": 'application/json'
            }

        };

        let xml =`<fetch page="${page}" count="${count}">
                    <entity name="${entity.name}">
                    ${fields.map((attr)=>(`<attribute name="${attr}" />`)).join("")}

                    ${xmlFilter?(xmlFilter):(
            `${filters ? `<filter type="and">
                            ${Object.keys(filters).map((f)=>(`<condition attribute="${f}" operator="eq" value="${filters[f]}" />`)).join("")}
                            </filter>`:""}`
        )}

                    ${join? join.map((joinedEntity)=>(`<link-entity name="${joinedEntity.entity.name}" from="${joinedEntity.from}" to="${joinedEntity.to}" link-type="${joinedEntity.type}" >
                                                        ${Object.keys(joinedEntity.entity.fields).map((joiendEntityField)=>(`<attribute name="${joiendEntityField}"/>`))}
                                                       </link-entity>`)) :""}
                    
                    ${orderBy? orderBy.map((order)=>(`<order attribute="${order.attributeName}" descending="${order.descending}" />`)) :""}
                    
                   
                    
                    </entity>
                </fetch>`



        let body = {
            FileName:fileName,
            EntitySetName:entity.name+"s",
            FetchXml:xml,
            Fields:excelFieldHeaders
        }
        try {
            // console.log(excelFieldHeader);
            let data = await Kian.post(`/Export/ToExcel`, body, headerConfig);
            onResult(data);
        }
        catch (e) {
            onError && onError(e)
        }
    }


    return {fetch, create, update, fetchLocal, toExcel, entity}
}

function useTokenEntityObject(entity) {

    /**
     *
     * @param token
     * @param onResult is an event that returns the results when received.
     * @param filters is an object contains the entity's field and values to filter the results.
     * @param fields is an array of the entity's fields
     * @param join
     * @param xmlFilter
     * @param orderBy
     * @returns {Promise<void>}
     */
    const fetch = async ({token, onResult,onError, fetchBody=null ,filters = undefined, fields = Object.keys(entity.fields), join, xmlFilter, orderBy, page=1, count=0})=>{
        // Object.keys(filters).forEach((f)=>{
        //     if (filters[f]===undefined){
        //         delete filters[f];
        //     }
        // })
        const headerConfig = {
            headers:{
                "Authorization": `Bearer ${token}`,//testToken
                "Content-Type": 'application/xml'
            }

        };
        let body = fetchBody?fetchBody:`<fetch page="${page}" count="${count}">
                    <entity name="${entity.name}">
                    ${fields.map((attr)=>(`<attribute name="${attr}" />`)).join("")}

                    ${xmlFilter?(xmlFilter):(`${filters ? `<filter type="and">
                            ${Object.keys(filters).map((f)=>(`<condition attribute="${f}" operator="eq" value="${filters[f]}" />`)).join("")}
                            </filter>`:""}`)}
                    
                    ${join? join.map((joinedEntity)=>(`<link-entity name="${joinedEntity.entity.name}" from="${joinedEntity.from}" to="${joinedEntity.to}" link-type="${joinedEntity.type}" >
                                                        ${Object.keys(joinedEntity.entity.fields).map((joiendEntityField)=>(`<attribute name="${joiendEntityField}"/>`))}
                                                       </link-entity>`)) :""}
                    
                    ${orderBy? orderBy.map((order)=>(`<order attribute="${order.attributeName}" descending="${order.descending}" />`)) :""}
                    </entity>
                </fetch>`
        try {
            let data = await Kian.post(`/Fetch/${entity.name}s`, body, headerConfig);
            onResult(data);
        }
        catch (e) {

            onError && onError(e);
        }
    }

    /**
     *
     * @param onResult is an event that returns the results when received.
     * @param filename a string filename.
     */
    const fetchLocal = async ({onResult})=>{
        try {
            let data = await axios.get(`assets/data/${entity.name}.json`);
            onResult(data);
        }
        catch ({response}) {
        }
    }

    /**
     *
     * @param token
     * @param onResult is an event that returns the results when received.
     * @param body is an object of field and values to create a row of the entity.
     * @param bind is a two params array [Entity, id] to bind the entity to another entity
     * @returns {Promise<void>}
     */
    const create = async ({token, onResult, body, bind = undefined})=>{

        const headerConfig = {
            headers:{
                "Authorization": `Bearer ${token}`,
            }
        };
        try {
            if (bind){
                const [field, bindedEntity, id] = bind;
                body[`${field}_${bindedEntity.name}@odata.bind`] = `/${bindedEntity.name}s(${id})`;
            }
            let data = await Kian.post(`/Proxy/${entity.name}s`, body , headerConfig);
            onResult(data);
        }
        catch (e) {
            // console.log(e);
        }
    }

    /**
     *
     * @param token
     * @param onResult is an event that returns the results when received.
     * @param id is a specific row uuid of the entity .
     * @param body is an object of field and values to update a row of the entity.
     * @returns {Promise<void>}
     */
    const update = async ({token, onResult, id, body})=>{

        const headerConfig = {
            headers:{
                "Authorization": `Bearer ${token}`,
            }
        };
        try {
            let data = await Kian.patch(`/Proxy/${entity.name}s(${id})`, body, headerConfig);
            onResult(data);
        }
        catch (e) {
            // console.log(e);
        }
    }

    return {fetch, create, update, fetchLocal, entity}
}


function useAuth() {
    const login_phone_number = async ({bodyData, onResult, onError}) => {
        try {
            let {data:{token}} = await Kian.post(`User/Login`, bodyData);
            onResult && onResult(token);
        }
        catch (e) {
            onError && onError(e)
        }
    }

    const verification = async ({bodyData, onResult, onError}) => {

        try {
            let {data:{token}} = await axios.post(`${Config.API_URL}User/ConfirmUser`, bodyData);
            // console.log(data)
            onResult && onResult(token)
        }
        catch (e){
            // console.log(e)
            onError && onError(e);
        }
    }

    const request_code = async ({bodyData, onResult, onError}) => {
        try {
            let {data} = await Kian.post(`User/CheckUser`, bodyData);
            onResult && onResult(data);
        }
        catch (e) {
            onError && onError(e);
        }
    }

    const update_password = async ({bodyData, token, onResult, onError}) => {
        const headerConfig = {
            headers:{
                "Authorization": `Bearer ${token}`,
            }
        };
        try {
            let {data} = await Kian.post(`User/ChangePassword`, bodyData, headerConfig);
            onResult && onResult(data);
        }
        catch (e) {
            onError && onError(e);
        }
    }

    return {login_phone_number, verification, request_code, update_password}
}

export {useEntityObject, useTokenEntityObject, useAuth}